<template>
    <g>
        <path
            d="M25 9V12.9606L27 12.9606V9C27 7.89543 26.1046 7 25 7H7C5.89543 7 5 7.89543 5 9V23C5 24.1046 5.89543 25 7 25H15.6454V23H7L7 9L25 9Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27.2998 17.8408C27.2998 16.5698 26.0181 15.6991 24.8366 16.1675L19.2875 18.3669C18.6013 18.6389 18.1507 19.3023 18.1507 20.0403V21.362C18.1507 22.2447 18.7909 22.9973 19.6622 23.1388L19.8961 23.1768L21.0451 26.6237L22.563 26.1177L21.6792 23.4663L25.2113 24.0398C26.3062 24.2176 27.2998 23.3723 27.2998 22.2631V17.8408ZM25.4261 17.6549C25.5574 17.6029 25.6998 17.6996 25.6998 17.8408V22.2631C25.6998 22.3863 25.5894 22.4803 25.4677 22.4605L24.1367 22.2444V18.2873C24.1367 18.2472 24.1338 18.2079 24.1281 18.1694L25.4261 17.6549ZM22.5367 18.8001V21.9846L19.9187 21.5595C19.8219 21.5437 19.7507 21.4601 19.7507 21.362V20.0403C19.7507 19.9582 19.8009 19.8845 19.877 19.8543L22.5367 18.8001Z"
        />
        <path d="M9.95117 19.5H15.4512V17.5H9.95117V19.5Z" />
        <path d="M19.9512 12.5H9.95117V14.5H19.9512V12.5Z" />
    </g>
</template>
